/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { MmcService } from "app/services/mmc.service";

export const DefaultPageSize = 10;
export const PageSizeProperty = "userMmcsPerPage";

@Injectable()
export class MmcAffiliatesResolver implements Resolve<string[]> {

    constructor(
        private mmcService: MmcService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<string[]> {
      try {
        return await this.mmcService.getAffiliates();
      } catch (error) {
        console.error("Problem resolving MMC Affiliates!", error);
      }
    }

}
